import React from 'react';
import { Card, CardBody, CardWrapper } from 'cdk-radial';
import classes from './CardDisplay.module.css';

const CardDisplay = (props) => {
    return (
        <Card className={classes['card-display']}>
            <CardWrapper draggable={false}>
                <CardBody className={classes['card-body']}>
                    {props.children}
                </CardBody>
            </CardWrapper>
        </Card>
    );
}

export default CardDisplay;